import { css } from '@emotion/react'

const disableAll = css`
	appearance: none;
	outline: none;
	border: 0;
`

export const BrowserStyles = {
	disableAll
}
